export const menuList = [
    {
        "id":"techeco_2022_001",
        "name":"Home",
        "linkTo":"/",
        "public":true,
        "isActive":true
    },
    {
        "id":"techeco_2022_002",
        "name":"About us",
        "linkTo":"/about_us",
        "public":true,
        "isActive":true,
    },
    {
        "id":"techeco_2022_003",
        "name":"Services",
        "subMenu":[
            {"id":"techeco_2022_003/001","name":"E-Waste","linkTo":"/services/e_waste","public":true,"isActive":true},
            {"id":"techeco_2022_003/002","name":"Battery Waste","linkTo":"/services/battery_waste","public":true,"isActive":true},
            {"id":"techeco_2022_003/003","name":"Plastic Waste","linkTo":"/services/plastic_waste","public":true,"isActive":true},
            {"id":"techeco_2022_003/004","name":"Automobile Waste","linkTo":"/services/automobile_waste","public":true,"isActive":true},
            {"id":"techeco_2022_003/005","name":"Glass Waste","linkTo":"/services/glass_waste","public":true,"isActive":true},
            {"id":"techeco_2022_003/006","name":"Rubber Waste","linkTo":"/services/rubber_waste","public":true,"isActive":true}
        ],
        "public":true,
        "isActive":true,
    },
    {
        "id":"techeco_2022_004",
        "name":"Initiatives",
        "linkTo":"/initiatives",
        "public":true,
        "isActive":true,
    },
    {
        "id":"techeco_2022_005",
        "name":"EPR",
        "linkTo":"/epr_for_e-waste",
        "public":true,
        "isActive":true,
    },
    // {
    //     "id":"techeco_2022_006",
    //     "name":"Blogs",
    //     "linkTo":"/tecteco/blogs",
    //     "public":true,
    //     "isActive":true,
    // },
    {
        "id":"techeco_2022_007",
        "name":"Contacts",
        "linkTo":"/contacts",
        "public":true,
        "isActive":true,
    },
    {
        "id":"techeco_2022_008",
        "name":"1800-889-3121",
        "public":true,
        "isActive":true,
    }

];